<div class="fill-height d-flex justify-content-center">
  <div class="d-flex w-100 flex-grow-1 position-relative">
    <div class="d-flex flex-column position-absolute w-100 h-100 overflow-auto">

      <!-- ========================== SCROLL AREA ========================== -->
      <div class="d-flex flex-column px-lg-big-q-and-a">

        <h4 class="py-0 px-1 m-0 d-flex pb-2 pb-md-4 pt-md-3">
          <b>
            {{ "main-nav.q-and-a" | translate }}
          </b>
        </h4>

        <!-- ========================== Qs AREA ========================== -->
        <div class="w-100 flex-grow-1 d-flex">
          <mat-accordion class="w-100" [class.zx-rtl]="isRTL">

            <!-- --------- Q1 --------- איך מדפיסים באיזיקס? -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a">
                <p>
                  {{ "q-and-a.1.content-1" | translate }}
                </p>
                <p class="fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "q-and-a.1.content-2" | translate }}
                </p>
                <p>
                  {{ "q-and-a.1.content-3" | translate }}
                </p>
                <p class="fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "q-and-a.1.content-4" | translate }}
                </p>
                <!-- plotter -->
                <div class="d-flex row">
                  <div class="d-flex col-12 col-lg-4 flex-column gap-2 pb-3">
                    <div class="d-flex col-12 col-md-6 align-items-center gap-2">
                      <img
                        class="zx-medium-small-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85 p-2"
                        [src]="'assets/images/plotter-icon.svg'">
                      <span class="zx-fit-text-q-and-a fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                        {{ "choose-system.printer.plotter" | translate }}
                      </span>
                    </div>
                    <p class="px-2 mb-1">
                      {{ "q-and-a.1.content-plotter-1" | translate }}
                    </p>
                    <span class="spacer d-none d-lg-flex"></span>
                    <button type="button" mat-stroked-button color="primary"
                      class="zx-small-tiny-btn rounded-pill mx-2 d-none d-lg-flex" (click)="goToNewOrder()">
                      {{ "q-and-a.1.btn-try" | translate }}
                    </button>
                  </div>
                  <!-- // plotter -->
                  <!-- express -->
                  <div class="d-flex col-12 col-lg-4 flex-column gap-2 pb-3">
                    <div class="d-flex col-12 col-md-6 align-items-center gap-2">
                      <img
                        class="zx-medium-small-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85 p-2"
                        [src]="'assets/images/express-icon.svg'">
                      <span class="zx-fit-text-q-and-a fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                        {{ "choose-system.printer.express" | translate }}
                      </span>
                    </div>
                    <p class="px-2 mb-1">
                      {{ "q-and-a.1.content-express-1" | translate }}
                    </p>
                    <span class="spacer d-none d-lg-flex"></span>
                    <button type="button" mat-stroked-button color="primary"
                      class="zx-small-tiny-btn rounded-pill mx-2 d-none d-lg-flex" (click)="goToNewOrder()">
                      {{ "q-and-a.1.btn-try" | translate }}
                    </button>
                  </div>
                  <!-- // express -->
                  <!-- pics -->
                  <div class="d-flex col-12 col-lg-4 flex-column gap-2 pb-3">
                    <div class="d-flex col-12 col-md-6 align-items-center gap-2">
                      <img
                        class="zx-medium-small-icon-size zx-medium-icon-size-lg rounded-2 zx-border-gray-v-v-light shadow-85 p-2"
                        [src]="'assets/images/pics-icon.svg'">
                      <span class="zx-fit-text-q-and-a fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                        {{ "choose-system.printer.pics" | translate }}
                      </span>
                    </div>
                    <p class="px-2 mb-1">
                      {{ "q-and-a.1.content-pics-1" | translate }}
                    </p>
                    <span class="spacer"></span>
                    <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill mx-2"
                      [class.text-white]="isDarkMode" (click)="goToNewOrder()">
                      {{ "q-and-a.1.btn-try" | translate }}
                    </button>
                  </div>
                  <!-- // pics -->
                </div>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q1 --------- איך מדפיסים באיזיקס? -->

            <!-- --------- Q2 --------- מהי הדפסת פלוטר? -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "my-orders.what-is-plotter" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.1.content-plotter-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToNewOrder()" [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.btn-try" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q2 --------- מהי הדפסת פלוטר?  -->

            <!-- --------- Q3 --------- מהי הדפסת מסמכים? -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "my-orders.what-is-express" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <b class="pb-3" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "choose-system.printer.express" | translate }}
                </b>
                <p>
                  {{ "q-and-a.1.content-express-1" | translate }}
                </p>
                <b class="pb-3" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "choose-system.printer.pics" | translate }}
                </b>
                <p>
                  {{ "q-and-a.1.content-pics-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToNewOrder()" [class.text-white]="isDarkMode">
                  {{ "q-and-a.1.btn-try" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q3 --------- מהי הדפסת מסמכים? -->

            <!-- --------- Q4 --------- איך לערוך קובץ להדפסה? -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.2.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.2.content-1" | translate }}
                </p>
                <p class="fw-bold" [class.zx-text-gray-darker]="!isDarkMode">
                  {{ "q-and-a.2.content-2" | translate }}
                </p>
                <p>
                  {{ "q-and-a.2.content-3" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="openWhatsAppEditMode('Editing-Instructions-At-Eazix')" [class.text-white]="isDarkMode">
                  {{ "q-and-a.2.btn" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q4 --------- איך לערוך קובץ להדפסה? -->

            <!-- --------- Q5 --------- מהן שעות הפעילות של הסניפים? -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.3.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a">
                <p>
                  {{ "q-and-a.3.content-1" | translate }}
                </p>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q5 --------- מהן שעות הפעילות של הסניפים? -->

            <!-- --------- Q6 --------- הוראות הגעה לסניפים -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.4.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.4.content-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="openWhatsAppEditMode('Arrival-Instructions-To-Eazix-Printers')"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.2.btn" | translate }}
                </button>
                <p class="pt-3">
                  {{ "q-and-a.2.content-3" | translate }}
                </p>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q6 --------- הוראות הגעה לסניפים -->

            <!-- --------- Q7 --------- איזה סוגי נייר יש? -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title class="zx-text-small zx-text-sm-medium" [class.text-green]="!isDarkMode"
                  [class.text-white]="isDarkMode">
                  {{ "q-and-a.5.title" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="d-flex flex-column w-100 px-2 px-md-4 zx-max-w-q-and-a pb-3">
                <p>
                  {{ "q-and-a.5.content-1" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="goToNewOrder()" [class.text-white]="isDarkMode">
                  {{ "choose-system.step-1" | translate }}
                </button>
                <p class="pt-3">
                  {{ "q-and-a.5.content-2" | translate }}
                </p>
                <button type="button" mat-stroked-button color="primary" class="zx-small-tiny-btn rounded-pill"
                  (click)="openWhatsAppEditMode('Papers-Info-At-Eazix')" [class.text-white]="isDarkMode">
                  {{ "q-and-a.2.btn" | translate }}
                </button>
              </div>
            </mat-expansion-panel>
            <!-- // --------- Q7 --------- איזה סוגי נייר יש? -->

          </mat-accordion>
        </div>
        <!-- // ========================== Qs AREA ========================== -->

      </div>
      <!-- // ========================== SCROLL AREA ========================== -->

    </div>
  </div>

</div>

<div class="p-2 d-flex flex-column">
  <div class="pt-md-2 d-flex justify-content-center px-lg-big-q-and-a">
    <button class="w-100 rounded-pill fw-bold" [class.text-green]="!isDarkMode" [class.text-white]="isDarkMode"
      mat-flat-button type="button" (click)="goToNewOrder()">
      {{ "main-nav.new-order" | translate }}
    </button>
  </div>
</div>